import React, { FC } from 'react';

import imageHelper from '@/src/assets/helpers/imageHelper';
import { ITheme } from '@/src/assets/interfaces/themeInterface';

import NextImage from '../../UI/nextImage/NextImage';
import { Title } from '../../UI/title/Title';
import Wrapper from '../../UI/wrapper/Wrapper';
import ButtonsGroup from '../../buttonsGroup/ButtonsGroup';

import styles from './MainInfo.module.scss';

type TMain = {
    themeData: Partial<ITheme>;
};

const MainInfo: FC<TMain> = ({ themeData }) => {
    const { price, title, pageTitle, excerpt, logo, themeDesktop, themeMobile, demoList } =
        themeData;

    const logoImage = logo && imageHelper(logo);
    const mobileImage = imageHelper(themeMobile);
    const desktopImage = imageHelper(themeDesktop);

    return (
        <section className={styles.section__container}>
            <Wrapper className={styles.section__wrapper}>
                <div className={styles.section__left}>
                    {logoImage && (
                        <NextImage
                            src={logoImage.url}
                            alt={logoImage.alt ?? ''}
                            className={styles.logo}
                            width={logoImage.width ?? 120}
                            height={logoImage.height ?? 40}
                        />
                    )}

                    <div className={styles.section__info}>
                        <Title text={pageTitle!} size="xl" className={styles['section-heading']} />
                        <p className={`excerpt body-lg ${styles.excerpt} `}>{excerpt!}</p>
                        <ButtonsGroup
                            price={price!}
                            preview={demoList && demoList[0] ? demoList[0].demoPreview : '/'}
                            title={title!}
                            purchaseUrl={themeData.purchaseUrl!}
                        />
                    </div>
                </div>
                <div className={styles.theme__right}>
                    <div className={styles.theme__mobile}>
                        <NextImage
                            src={mobileImage.url}
                            alt={mobileImage.alt ?? 'Theme mobile'}
                            fill
                            priority
                            sizes="
                                      (max-width: 475px) 20.73vw,
                                      (max-width: 576px) 24vw,
                                      (max-width: 768px) 20vw,
                                      (max-width: 1024px) 17.19vw,
                                                          176px"
                        />
                    </div>
                    <div className={styles.theme__desktop}>
                        <NextImage
                            src={desktopImage.url}
                            alt={desktopImage.alt ?? 'Theme desktop'}
                            fill
                            priority
                            sizes="
                                      (max-width: 475px) 77vw,
                                      (max-width: 576px) 80vw,
                                      (max-width: 768px)  65vw,
                                      (max-width: 1024px) 52.14vw,
                                      (max-width: 1200px) 47.2vw,
                                                          534px"
                        />
                    </div>
                </div>
            </Wrapper>
        </section>
    );
};

export default MainInfo;
